/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    userList: {
        "userName": "用户名",
        "password": "密码",
        "mobileNumber": "手机号码",
        "mail": "邮箱",
        "updateTime": "更新时间",
        "state": "状态",
        "edit": "编辑",
        "disable": "禁用",
        "enable": "启用",
        "changePassword": "修改密码",
        "delete": "删除",
        "remarks": "备注",
        "newPassword": "新密码",
        "confirmPassword": "确认密码",
        "userList": "用户列表",
        "addUser": "新增用户",
        "editUser": "编辑用户",
        "back": "返回",
        "save": "保存",
        "applyName": "应用名称",
        "roleNumber": "角色编号",
        "roleName": "角色名称",

        "message1": "修改密码成功",
        "message2": "请输入新密码",
        "message3": "请输入确认密码",
        "message4": "数字字母组合，不少于6位",
        "message5": "请输入手机号码",
        "message6": "请输入邮箱",
        "message7": "保存成功",
        "message8": "请填写密码",

        "text1": "用户已分配角色",
        "text2": "用户账号信息",
        "text3": "应用及关联角色",
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/tc/userList.js